import { useFlags } from 'flagsmith/react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useLocalFeatureFlags } from 'app/lib/feature-flags/useLocalFeatureFlags';

export const useFeatureFlag = (featureFlag: FeatureFlag) => {
  const {
    hasFeatureFlag: hasLocalFeatureFlag,
  } = useLocalFeatureFlags();

  const flagsmithFeatureFlag = useFlags([featureFlag]);

  return hasLocalFeatureFlag(featureFlag) || flagsmithFeatureFlag[featureFlag].enabled;
};
